import { HttpError, useCreate } from '@refinedev/core';

type GenerateMeetingNoteInput = {
  templateId: string;
};

type UseGenerateCalendarEventMeetingNoteResult = {
  generateMeetingNote: (input: GenerateMeetingNoteInput) => Promise<void>;
  isLoading: boolean;
  error: HttpError | null;
};

export const useGenerateCalendarEventMeetingNote = (
  eventId: string,
): UseGenerateCalendarEventMeetingNoteResult => {
  const { mutateAsync, error, isLoading } = useCreate<GenerateMeetingNoteInput>({
    resource: `calendar-events/${eventId}/meeting-notes`,
  });

  const generateMeetingNote = async (input: GenerateMeetingNoteInput) => {
    await mutateAsync({
      values: input,
    });
  };

  return {
    generateMeetingNote,
    isLoading,
    error,
  };
};
